export default {"src":"/_next/static/media/ra-parts-inventory.62f8ca76.svg","height":25,"width":24,"blurWidth":0,"blurHeight":0};